export class EnumHelper {
    static getEnumEnumerableEntries<T>(enumObj: any, displayValueConverter: (value: T) => string) {
        return Object.entries(enumObj).filter(([key, value]) => typeof(key) === "string" && typeof(value) === "string").map(([key, value]) => ({
            enumKey: key,
            enumValue: value as T,
            displayValue: displayValueConverter(value as T)
        }));
    }
}